import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import HowItWorks from '../components/HowItWorks/HowItWorks';
import GetStarted from '../components/GetStarted/GetStarted';
import Support from '../components/Support/Support';
import Outro from '../components/Outro/Outro';
import Footer from '../components/Footer/Footer';

function Home() {
  const location = useLocation();

  // Handle scroll to anchor when navigating from another page
  useEffect(() => {
    if (location.hash) {
      const elementId = location.hash.replace('#', '');
      const element = document.getElementById(elementId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="home-page">
      <Header />
      <main>
        <Hero />
        <HowItWorks />
        <GetStarted />
        <Support />
        <Outro />
      </main>
      <Footer />
    </div>
  );
}

export default Home;
